module.exports = __webpack_public_path__ + "img/jomalone_logo_header.f57da1f2.png";